import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ServiceCard = ({ icon, title, description, features, delay }) => (
  <motion.div 
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6, delay }}
    className="group relative bg-dark-900 border border-white/5 p-10 transition-all duration-500 hover:bg-dark-800"
  >
    <div className="w-16 h-16 bg-dark-800 flex items-center justify-center text-gold-500 mb-8 group-hover:bg-gold-500 group-hover:text-black transition-all duration-300">
      <SafeIcon icon={icon} className="w-8 h-8" />
    </div>

    <h3 className="text-2xl font-black text-white mb-5 uppercase tracking-tighter group-hover:text-gold-500 transition-colors">{title}</h3>
    <p className="text-gray-400 mb-10 text-base font-bold leading-relaxed tracking-tight">{description}</p>
    
    <ul className="space-y-4 border-t border-white/5 pt-8">
      {features.map((feature, idx) => (
        <li key={idx} className="flex items-start text-sm font-black text-gray-300 uppercase tracking-tight">
          <SafeIcon icon={FiIcons.FiCheck} className="w-4 h-4 text-gold-500 mr-3 mt-0.5 flex-shrink-0" />
          <span>{feature}</span>
        </li>
      ))}
    </ul>
  </motion.div>
);

const Services = () => {
  const services = [
    {
      icon: FiIcons.FiUser,
      title: "PT in Presenza",
      description: "Allenamenti individuali svolti direttamente in palestra. Ideale per chi cerca supervisione tecnica costante.",
      features: ["Correzione real-time", "Programmazione guidata", "FitActive Treviglio"]
    },
    {
      icon: FiIcons.FiMonitor,
      title: "Coaching Online",
      description: "Programmazione completa con monitoraggio a distanza. Per chi vuole allenarsi con metodo ovunque.",
      features: ["Piano personalizzato", "Check periodici", "Supporto WhatsApp"]
    },
    {
      icon: FiIcons.FiActivity,
      title: "Performance 360°",
      description: "Il percorso ibrido definitivo. Combina presenza e online per non lasciare nulla al caso.",
      features: ["Sessioni live + App", "Focus mobilità e forza", "Analisi posturale"]
    },
    {
      icon: FiIcons.FiTarget,
      title: "Percorso Calcio",
      description: "Costruisci le qualità fisiche per spiccare in campo. Palestra + Campo per la massima resa.",
      features: ["Forza specifica", "Prevenzione infortuni", "Off-season training"]
    }
  ];

  return (
    <section id="percorsi" className="py-32 bg-dark-900 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-20">
          <span className="text-gold-500 uppercase tracking-[0.4em] text-xs font-black mb-4 block">Cosa Offro</span>
          <h2 className="text-5xl md:text-7xl font-black text-white tracking-tighter uppercase leading-none">
            I MIEI <br/> <span className="text-gray-700 italic font-black">PERCORSI.</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} delay={index * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;